import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { HStack, VStack } from '@/components/Layout';
import { Skeleton } from '@/components/ui/skeleton';
import { IncidentDetailHeader } from './-components/IncidentDetailHeader';
import { IncidentDetailOutletWithForm } from './_layout/-context/incident-tab-form-context';
import { IncidentFormStore } from './_layout/-store/store';
export const Route = createFileRoute('/_stacktrace/incidents/$incidentId/_layout')({
  component: Layout
});
function IncidentDetailHeaderSkeleton() {
  return <VStack className="gap-3 bg-neutral-fill px-12 pt-4 shadow-sm">
      <HStack className="items-start justify-between gap-6">
        <HStack className="items-start gap-6 grow">
          <Skeleton className="size-20 shrink-0 rounded-md" />
          <VStack className="grow gap-2">
            <Skeleton className="h-6 w-32 rounded-full" />
            <Skeleton className="h-8 w-72" />
          </VStack>
        </HStack>
      </HStack>
    </VStack>;
}
function Layout() {
  const store = IncidentFormStore.createStore();
  return <IncidentFormStore.Provider value={store}>
      <VStack>
        <Suspense fallback={<IncidentDetailHeaderSkeleton />}>
          <IncidentDetailHeader />
        </Suspense>
        <Suspense fallback={<div className="flex-1 px-12 py-5" />}>
          <IncidentDetailOutletWithForm />
        </Suspense>
      </VStack>
    </IncidentFormStore.Provider>;
}